export interface GetYurticiCargoAgreementListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetYurticiCargoAgreementListPagingAndFilterResponseData
}

export interface GetYurticiCargoAgreementListPagingAndFilterResponseData {
    items: GetYurticiCargoAgreementListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetYurticiCargoAgreementListPagingAndFilterResponseItem {
    yurticiCargoAgreementId: string
    companyId: string
    refNo?: string
    agreementSchemeId: string
    potTypeId: string
    startDate: string
    endDate: string
    unitPrice: number
    minPrice: number
    agreementSchemeName: string
    potTypeName: string
    yurticiCargoAgreementScales: GetYurticiCargoAgreementListPagingAndFilterResponseYurticiCargoAgreementScale[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetYurticiCargoAgreementListPagingAndFilterResponseYurticiCargoAgreementScale {
    yurticiCargoAgreementScaleId: string
    yurticiCargoAgreementId: string
    startPrice: number
    unitPrice: number
    interval: number
}

export const initialGetYurticiCargoAgreementListPagingAndFilterResponseData: GetYurticiCargoAgreementListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}